import React, { useState, useEffect, useCallback } from 'react'
import './LoginForm.css'
import axios from '../api/apiClient';
import { token, domain } from './Security';
// import { HR7_SERVICE_ID, HR7_IS_CLOUD } from '../config/cloudConfig';
import { LoadingSpinner } from '../common/Loading'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {
  setRootIPAddress,
  setRootPort,
  getIPAddress,
  getPort,
  setRootIPAddressBiometrics,
  setRootPortBiometrics,
  getIPAddressBiometrics,
  getPortBiometrics,
  setRootIPAddress2,
  setRootPort2,
  getIPAddress2,
  getPort2,
  setRootIPAddressBiometrics2,
  setRootPortBiometrics2,
  getIPAddressBiometrics2,
  getPortBiometrics2
} from './Security';
import {
  setDatabase,
  setSentryDatabase,
  setClientLicenseKey,
  setClientCloudConfig,
  clearClientCloudConfig,
} from './Security';
import { HR7_SERVICE_ID, HR7_IS_CLOUD, HR7_SUBSCRIPTION_DOMAIN } from './Security';
import { // Unli Account Config
  setUnliAccount,
  getUnliAccount,
} from './Security';
import { checkUserLicenseIfActive, checkUnlimitedAccount } from '../api/subscriptionApi';

import { SetAuditTrail } from './Reports/AuditTrailReportEmployeeSetup';
//icons
import PersonIcon from '@mui/icons-material/Person';
import LockIcon from '@mui/icons-material/Lock';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LanIcon from '@mui/icons-material/Lan';
import VerifiedIcon from '@mui/icons-material/Verified';
import { setClientIdentity } from '../config/client';

const LoginForm = ({ handleLogin }) => {
  const [users, setUsers] = useState(null);
  const [accessTemplates, setAccessTemplates] = useState(null);
  const [dataFetched, setDataFetched] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [adminMode, setAdminMode] = useState(false);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);

  const [code, setCode] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [adminUsername, setAdminUsername] = useState("");
  const [adminPassword, setAdminPassword] = useState("");
  const [webIP, setWebIP] = useState(getIPAddress);
  const [webPort, setWebPort] = useState(getPort);
  const [bioIP, setBioIP] = useState(getIPAddressBiometrics);
  const [bioPort, setBioPort] = useState(getPortBiometrics);
  const [webIP2, setWebIP2] = useState(getIPAddress2);
  const [webPort2, setWebPort2] = useState(getPort2);
  const [bioIP2, setBioIP2] = useState(getIPAddressBiometrics2);
  const [bioPort2, setBioPort2] = useState(getPortBiometrics2);

  const [selectedTab, setSelectedTab] = useState(0);

  const handleSelectChange = (index) => {
    setSelectedTab(index);
  };

  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");
  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);
  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  // Verify Code - start
  const [isCodeVerified, setIsCodeVerified] = useState(false);

  const verifyCodeHandleClick = async () => {
    if (!code) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Please enter a code");
      return;
    }

    setLoadingRequest(true);

    try {
      const response = await axios.get( HR7_SUBSCRIPTION_DOMAIN + '/api/clientStatusByCode',
        {
          params: {
            serviceId: HR7_SERVICE_ID,
            code: code
          }
        }
      );

      // ✅ adjust based on actual API response structure
      if (
        response.data &&
        response.data.database &&
        response.data.clientLicenseKey
      ) {
        setDatabase(response.data.database);
        setSentryDatabase(response.data.database2);
        setClientLicenseKey(response.data.clientLicenseKey);

        setClientCloudConfig({
          database: response.data.database,
          clientLicenseKey: response.data.clientLicenseKey,
          serviceId: response.data.serviceId
        });

        setIsCodeVerified(true);
        setShowRequestMessage(true);
        setIsSuccess(true);
        setRequestMessage("Code verified successfully");
      } else {
        setIsCodeVerified(false);
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Invalid or inactive code");
      }

    } catch (error) {
      console.error(error);
      setIsCodeVerified(false);
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Failed to verify code");
    } finally {
      setLoadingRequest(false);
    }
  };

  // Verify Code - end
  const apiUrl = domain + "/api/Authentication";
  const apiUrlClientIdentity = domain + "/api/ClientIdentity";
  const apiUrlAccessTemplate = domain + "/api/AccessTemplate";

  const loginHandleClick = async (e) => {
    e.preventDefault();
    setLoadingRequest(true);

    // 🔒 REQUIRE VERIFIED CODE (cloud only)
    if (HR7_IS_CLOUD && !isCodeVerified) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Please verify Client Id first");
      setLoadingRequest(false);
      return;
    }

    if(!HR7_IS_CLOUD) { // reset config
      clearClientCloudConfig();
    }

    if (!username || !password) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Please input username and password");
      setLoadingRequest(false)
      return;
    }


    const data = {
      username: username,
      password: password
    };

    try {
      const response = await axios.post(apiUrl + `/login`, data, {
        headers: {
          // 'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      const clientIdentityResponse = await axios.get(apiUrlClientIdentity + `/get-client-identity`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const employeeId = response.data.employeePersonalInformationEmployeeId;
      const license = response.data?.license ?? '';


      // used for client capabilities
      const clientIdentityName = clientIdentityResponse.data.clientIdentityName;
      setClientIdentity(clientIdentityName);

      // check if the subscription status of the user if active?
      
      const isUnlimitedAccount = await checkUnlimitedAccount(); // make to set " in ClientIdentity | ClientIdentityController
      setUnliAccount(isUnlimitedAccount);
      const HR7_UNLI_ACCOUNT = getUnliAccount();

      
      const userLicenseIsActive = HR7_IS_CLOUD ? await checkUserLicenseIfActive(employeeId, license) : false;

      if (HR7_IS_CLOUD && HR7_UNLI_ACCOUNT ) {
        setShowRequestMessage(true);
        setIsSuccess(true);
        setRequestMessage("Unli Acount Activated.");
        setLoadingRequest(false);
      }
      else if (HR7_IS_CLOUD && userLicenseIsActive === false) {
        setShowRequestMessage(true);
        setIsSuccess(false);
        setRequestMessage("Login failed, no license.");
        setLoadingRequest(false);
        return;
      }

      // Fetch data after successful login
      await fetchData(response.data.username);
      await fetchDataAccessTemplate(response.data.accessTemplateId);

      await SetAuditTrail({
        setupArea: "Login Form",
        actionTaken: "login",
        field: "Login Form",
        newValue: `${response.data.employeePersonalInformationFullName}`,
        oldValue: "-",
        dateSaved: new Date(),
        savedById: response.data.id
      });

      /* const foundEmployee = users.find(employee => employee.username === username);
      const foundEmployeeAccesstemplate = accessTemplates.find(employee => employee.id === foundEmployee.accessTemplateId);

      handleLogin(foundEmployee, foundEmployeeAccesstemplate); */
      setDataFetched(true);
    } catch (error) {
      setLoadingRequest(false)
      setShowRequestMessage(true);
      setIsSuccess(false);
      console.error('Error:', error);

      if (error.response && error.response.data && error.response.data.errors) {
        const errorArray = error.response.data.errors.Password;
        if (errorArray && errorArray.length > 0) {
          const errorMessage = errorArray[0];
          setRequestMessage(errorMessage);
        } else {
          setRequestMessage("Unknown password error occurred.");
        }
      } else if (error.response && error.response.data && error.response.data.message) {
        const errorMessage = error.response.data.message;
        setRequestMessage(errorMessage);
      } else {
        setRequestMessage("An unknown error occurred.");
      }
    } finally {
      setLoadingRequest(false);
    }
  }
  const loginAdminHandleClick = async (e) => {
    e.preventDefault();

    if (!adminUsername || !adminPassword) {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Please input username and password");
      setLoadingRequest(false)
      return;
    }

    if (adminUsername !== "admin" && adminPassword !== "password") {
      setShowRequestMessage(true);
      setIsSuccess(false);
      setRequestMessage("Invalid username or password");
      setLoadingRequest(false)
      return;
    }

    setIsAdminLoggedIn(true);
  }
  const logoutAdminHandleClick = async (e) => {
    e.preventDefault();

    window.location.pathname = "/";

    /* setAdminUsername("");
    setAdminPassword("");
    setWebIP(getIPAddress);
    setWebPort(getPort);
    setBioIP(getIPAddressBiometrics);
    setBioPort(getPortBiometrics);

    setIsAdminLoggedIn(false); */
  }
  const saveSettings = async (e) => {
    e.preventDefault();

    setShowRequestMessage(true);
    setIsSuccess(true);
    setRequestMessage("Initial Settings Saved");
    setLoadingRequest(false)

    setRootIPAddress(webIP);
    setRootPort(webPort);
    setRootIPAddressBiometrics(bioIP);
    setRootPortBiometrics(bioPort);
    setRootIPAddress2(webIP2);
    setRootPort2(webPort2);
    setRootIPAddressBiometrics2(bioIP2);
    setRootPortBiometrics2(bioPort2);
  }

  const onAdminModeHandleClick = () => {
    setAdminMode(true);
    setCode("");
    setUsername("");
    setPassword("");
  }
  const offAdminModeHandleClick = () => {
    setAdminMode(false);
    setAdminUsername("");
    setAdminPassword("");
  }

  const fetchData = useCallback(async (_username) => {
    try {
      const response = await axios.get(apiUrl + `/username/${_username}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      setUsers(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
    }
  }, [apiUrl]);
  const fetchDataAccessTemplate = useCallback(async (_accessTemplateId) => {
    try {
      const response = await axios.get(apiUrlAccessTemplate + `/${_accessTemplateId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json' // You can include other headers if needed
        }
      })
      setAccessTemplates(response.data); // Set the response data to the state
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
    }
  }, [apiUrlAccessTemplate]);

  useEffect(() => {
    if (dataFetched) {
      // const foundEmployee = users.find(employee => employee.username.trim().toLowerCase() === username.trim().toLowerCase());
      // const foundEmployeeAccesstemplate = accessTemplates.find(employee => employee.id === foundEmployee.accessTemplateId);
      const foundEmployee = users;
      const foundEmployeeAccesstemplate = accessTemplates;
      handleLogin(foundEmployee, foundEmployeeAccesstemplate);
      setDataFetched(false);
    }
  }, [dataFetched, users, handleLogin, accessTemplates, username]);

  return (
    <>
      <div className='wrapper-holder row'>
        <div className='logo-login'>
          <img src="logo/logo.png" alt="logo" />
        </div>
        <div className='column'>
          {!adminMode ?
            <div className='wrapper row shadow-xl'>
              <form action=''>
                <h1 style={{ color: '#668fca' }}>Login</h1>

                {HR7_IS_CLOUD && (
                  <div className="code-row">
                    <div className="input-box no-margin">
                      <input
                        type="text"
                        className=""
                        placeholder="Client Id"
                        value={code}
                        required
                        onChange={(e) => {
                          setCode(e.target.value);
                          setIsCodeVerified(false);
                          clearClientCloudConfig();
                        }}

                      />
                      <PersonIcon className="icon" />
                    </div>

                    <button
                      type="button"
                      className="verify-btn"
                      onClick={verifyCodeHandleClick}
                    >
                      Verify
                    </button>

                    {isCodeVerified && <div><VerifiedIcon className="icon text-blue-500" /></div> }

                  </div>
                )}

                <div className='input-box row'>
                  <input type='text' placeholder='Username' value={username} required onChange={(e) => setUsername(e.target.value)} />
                  <PersonIcon className='icon' />
                </div>
                <div className='input-box row'>
                  <input type='password' placeholder='Password' value={password} required onChange={(e) => setPassword(e.target.value)} />
                  <LockIcon className='icon' />
                </div>

                <div className='button-holder'>
                  <button type='submit' onClick={(e) => loginHandleClick(e)}>Login</button>
                </div>

                <div className='register-link' style={{ display: "none" }}>
                  <button className='adminMode-button' onClick={onAdminModeHandleClick}>Enter Client Id</button>
                </div>

                <div className='register-link' style={{ display: "none" }}>
                  <button className='adminMode-button' onClick={onAdminModeHandleClick}>Admin Mode</button>
                </div>
              </form>
            </div>
            :
            <div className={`wrapper row`}>
              {!isAdminLoggedIn ?
                <form action=''>
                  <h1 style={{ color: '#668fca', margin: '0' }}>
                    QS I.T Services
                  </h1>
                  <h3 style={{ color: '#668fca', margin: "0" }}>(Admin Mode)</h3>
                  <h3 style={{ color: 'rgb(104, 104, 104)' }}>Sign In</h3>
                  <div className='input-box row'>
                    <input type='text' placeholder='Username' value={adminUsername} required onChange={(e) => setAdminUsername(e.target.value)} />
                    <PersonIcon className='icon' />
                  </div>
                  <div className='input-box row'>
                    <input type='password' placeholder='Password' value={adminPassword} required onChange={(e) => setAdminPassword(e.target.value)} />
                    <LockIcon className='icon' />
                  </div>

                  <div className='button-holder'>
                    <button type='submit' onClick={(e) => loginAdminHandleClick(e)}>
                      Login
                    </button>
                    <button type='submit' style={{ marginTop: "10px", backgroundColor: "#fa4444" }} onClick={offAdminModeHandleClick}>
                      Back
                    </button>
                  </div>
                </form>
                :
                <form action=''>
                  <h1 style={{ color: '#668fca', margin: '0' }}>
                    Admin Mode
                  </h1>
                  <h2 style={{ color: 'rgb(104, 104, 104)' }}>Settings Configuration</h2>
                  <div className='loan-tab setting-tab'>
                    <Tabs selectedIndex={selectedTab} onSelect={index => handleSelectChange(index)}>
                      <TabList>
                        <Tab><b>Config 1</b></Tab>
                        <Tab><b>Config 2</b></Tab>
                      </TabList>
                      <div className="loan-tabPanel">
                        <TabPanel>
                          <div style={{ padding: "10px" }}>
                            <h4 style={{ margin: "0" }}>Web</h4>
                            <div className='input-box row' style={{ margin: "10px 0" }}>
                              <input type='text' placeholder='IP' value={webIP} required onChange={(e) => setWebIP(e.target.value)} />
                              <input type='text' placeholder='Port' value={webPort} required onChange={(e) => setWebPort(e.target.value)} />
                            </div>
                          </div>
                          <div style={{ padding: "10px" }}>
                            <h4 style={{ margin: "0" }}>Biometrics</h4>
                            <div className='input-box row' style={{ margin: "10px 0" }}>
                              <input type='text' placeholder='IP' value={bioIP} required onChange={(e) => setBioIP(e.target.value)} />
                              <input type='text' placeholder='Port' value={bioPort} required onChange={(e) => setBioPort(e.target.value)} />
                            </div>
                          </div>
                        </TabPanel>
                        <TabPanel>
                          <div style={{ padding: "10px" }}>
                            <h4 style={{ margin: "0" }}>Web</h4>
                            <div className='input-box row' style={{ margin: "10px 0" }}>
                              <input type='text' placeholder='IP' value={webIP2} required onChange={(e) => setWebIP2(e.target.value)} />
                              <input type='text' placeholder='Port' value={webPort2} required onChange={(e) => setWebPort2(e.target.value)} />
                            </div>
                          </div>
                          <div style={{ padding: "10px" }}>
                            <h4 style={{ margin: "0" }}>Biometrics</h4>
                            <div className='input-box row' style={{ margin: "10px 0" }}>
                              <input type='text' placeholder='IP' value={bioIP2} required onChange={(e) => setBioIP2(e.target.value)} />
                              <input type='text' placeholder='Port' value={bioPort2} required onChange={(e) => setBioPort2(e.target.value)} />
                            </div>
                          </div>
                        </TabPanel>
                      </div>
                    </Tabs>
                  </div>

                  <div className='button-holder'>
                    <button type='submit' onClick={(e) => saveSettings(e)}>
                      Save Settings
                    </button>
                    <button type='submit' style={{ marginTop: "10px", backgroundColor: "#fa4444" }} onClick={logoutAdminHandleClick}>
                      Logout
                    </button>
                  </div>
                </form>
              }
            </div>
          }
          <div className='row' style={{ alignItems: "center", justifyContent: "center" }}>
            <div className='column' style={{ padding: "20px 0px", color: "#a1a1a1", userSelect: "none" }}>
              <LanIcon />
            </div>
            <div className='column' style={{ padding: "20px 10px", color: "#a1a1a1", userSelect: "none" }}>
              <span>Powered By:</span>
              <span>QS I.T SERVICES Version 3.0</span>
            </div>
          </div>

        </div>

      </div>
      <GenerateMessage form={showRequestMessage}
        message={requestMessage}
        isSuccess={isSuccess}
      >
      </GenerateMessage>
      
      <LoadingSpinner loading={loadingRequest} />
    </>
  )
}

export default LoginForm
